import React from "react";
import { padWithZero } from "~/utils";

export default function RowInvoiceNumber({ id }: { id?: number }) {
  return id ? <>GEN-{padWithZero(id, 5)}</> : null;
}
